export type CompanyAddress = {
  id: string;
  label: string;
  fullAddress: string;
  streetAddress: string;
  addressLocality: string;
  addressRegion: string;
  postalCode?: string;
  addressCountry: string;
  isPrimary?: boolean;
};

export const COMPANY_ADDRESSES: CompanyAddress[] = [
  {
    id: 'truong-tho-head-office',
    label: 'Xưởng sản xuất',
    fullAddress:
      'Số 75 Đường Vũng Thiện, Khu phố Chiêu Liêu, Phường Dĩ An, Thành phố Hồ Chí Minh, Việt Nam',
    streetAddress: 'Số 75 Đường Vũng Thiện, Khu phố Chiêu Liêu',
    addressLocality: 'Phường Dĩ An',
    addressRegion: 'Thành phố Hồ Chí Minh',
    postalCode: '700000',
    addressCountry: 'VN',
    isPrimary: true,
  },
  {
    id: 'truong-tho-branch-2',
    label: 'Văn phòng',
    fullAddress: 'Đường số 3, Khu phố Đông Chiêu, Dĩ An, TP. Hồ Chí Minh',
    streetAddress: 'Đường số 3, Khu phố Đông Chiêu',
    addressLocality: 'Dĩ An',
    addressRegion: 'TP. Hồ Chí Minh',
    addressCountry: 'VN',
  },
];

export const PRIMARY_ADDRESS: CompanyAddress =
  COMPANY_ADDRESSES.find((address) => address.isPrimary) ?? COMPANY_ADDRESSES[0];

export const SECONDARY_ADDRESSES: CompanyAddress[] = COMPANY_ADDRESSES.filter(
  (address) => !address.isPrimary,
);

export const getCompanyAddressesJsonLd = () =>
  COMPANY_ADDRESSES.map((address) => {
    const jsonLdAddress: Record<string, string> = {
      '@type': 'PostalAddress',
      streetAddress: address.streetAddress,
      addressLocality: address.addressLocality,
      addressRegion: address.addressRegion,
      addressCountry: address.addressCountry,
    };

    if (address.postalCode) {
      jsonLdAddress.postalCode = address.postalCode;
    }

    return jsonLdAddress;
  });

